module.exports = __webpack_public_path__ + "static/media/corona.62ec830b.webp";